import { Typography } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';

import styles from '../Intimidad/Intimidad.module.css';

export const OpenMailBox = ({ openMailBox, handleOpenMailBox }) => {
  return (
    <div className={styles.intimidad}>
      <div className={styles.top}>
        <Typography
          variant="h6"
          style={{ fontWeight: 'bold', marginBottom: '15px' }}
        >
          Encuesta buzón abierto:
        </Typography>

        <Typography variant="body2" color="text.secondary">
          Al marcar esta pregunta como buzón abierto, podrás responder la
          encuesta varias veces.
        </Typography>
      </div>
      <div className={styles.bottom}>
        <FormControl>
          <FormControlLabel
            control={
              <Switch
                checked={openMailBox}
                onChange={(e) => handleOpenMailBox(e.target.checked)}
              />
            }
            label={
              openMailBox
                ? 'Sí. Encuesta con buzón abierto.'
                : 'No. Encuesta sin buzón abierto.'
            }
          />
        </FormControl>
      </div>
    </div>
  );
};
